import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HookHeader } from '../../../shared/models/hook-header';
import { HookHmac } from '../../../shared/models/hook-hmac';
import { HookBasic } from '../../../shared/models/hook-basic';
import { forkJoin, of } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { FlashService } from '../../../shared/components/flash/services/flash.service';
import { TechnicalService } from '../../services/technical.service';

function cleanObject(obj) {
  Object.keys(obj).forEach((key) => {
    if (key !== 'prefix') {
      obj[key] = ''
    }
  })
  return obj
}

@Component({
  selector: 'app-dialog-technical-credentials',
  templateUrl: './dialog-technical-credentials.component.html',
  styleUrls: ['./dialog-technical-credentials.component.sass']
})
export class DialogTechnicalCredentialsComponent implements OnInit {
  modelHeader: HookHeader;
  modelHmac: HookHmac;
  modelBasic: HookBasic;
  formSuccess = false;
  formError = false;
  loading = false;
  opened = {
    basic: false,
    hmac: false,
    header: false,
  }

  constructor(
    private technicalService: TechnicalService,
    private flashMessage: FlashService,
    public dialogRef: MatDialogRef<DialogTechnicalCredentialsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.modelHeader = { ...this.data.modelHeader };
    this.modelHmac = { ...this.data.modelHmac };
    this.modelBasic = { ...this.data.modelBasic };

    this.opened = {
      basic: !!this.modelBasic.username,
      hmac: !!this.modelHmac.secret,
      header: !!this.modelHeader.value,
    }
  }

  ngOnInit() {
  }

  onSubmit(event, formComponent: any) {
    event.preventDefault();

    this.formSuccess = false;
    this.formError = false;

    if (formComponent.form.valid) {
      forkJoin([
        this.updateHeader(this.modelHeader),
        this.updateHmac(this.modelHmac),
        this.updateBasic(this.modelBasic)
      ])
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        () => {
          this.formSuccess = true;
          this.flashMessage.success('technicals.webhooks.form.success');

          this.dialogRef.close({
            modelHeader: this.modelHeader,
            modelBasic: this.modelBasic,
            modelHmac: this.modelHmac
          });
        },
        () => {
          this.formError = true;
        }
      );
    } else {
      this.formError = true;
    }
  }

  updateHeader(data) {
    if (!this.opened.header) {
      cleanObject(this.modelHeader)
      return this.technicalService.deleteHeader();
    }
    return this.technicalService.updateHeader(data);
  }

  updateHmac(data) {
    if (!this.opened.hmac) {
      cleanObject(this.modelHmac)
      return this.technicalService.deleteHmac();
    }
    return this.technicalService.updateHmac(data);
  }

  updateBasic(data) {
    if (!this.opened.basic) {
      cleanObject(this.modelBasic)
      return this.technicalService.deleteBasic();
    }
    return this.technicalService.updateBasic(data);
  }

  onToggle(type) {
    this.opened[type] = !this.opened[type]
  }

  // onConfirm() {

  // }

  onCancel() {
    this.dialogRef.close(false);
  }
}
